module.exports = __webpack_public_path__ + "static/media/bnr_shocc2f51df7fd50411e9518d72854506e1.webp";